var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    staticClass: "scroll-top",
    attrs: {
      "color": "#ddd",
      "fab": "",
      "tile": "",
      "outlined": "",
      "fixed": "",
      "transition": "slide-x-transition"
    },
    on: {
      "click": function ($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }